export const QRSCONFIG_ACCESS_PASSWD = '0470a6205aff9e53eac1fafe7f6ccb91';
export const LOCALSTORAGE_KEY_LOGIN = 'qrsconfig@login'; 